import { render, staticRenderFns } from "./AddMediaDialog.vue?vue&type=template&id=52dd1e74&scoped=true"
import script from "./AddMediaDialog.vue?vue&type=script&lang=js"
export * from "./AddMediaDialog.vue?vue&type=script&lang=js"
import style0 from "./AddMediaDialog.vue?vue&type=style&index=0&id=52dd1e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd1e74",
  null
  
)

export default component.exports